var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "well" }, [
    _c("h4", [
      _vm._v(
        _vm._s(_vm.isEdit ? "Edit" : "Setup") +
          " Autoprovisioning Configuration"
      )
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "alert alert-info" }, [
          _c("p", [_vm._v("Processing...")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.error
      ? _c("div", { staticClass: "alert alert-danger" }, [
          _c("p", [_vm._v(_vm._s(_vm.error))])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.saveConfig.apply(null, arguments)
          }
        }
      },
      [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "control-label" }, [
            _vm._v("Roster Service *")
          ]),
          _vm._v(" "),
          _c("div", [
            _c("label", { staticClass: "radio-inline radio-option-first" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.lambdaInput.roster_service,
                    expression: "lambdaInput.roster_service"
                  }
                ],
                attrs: {
                  id: "roster-service-clever",
                  type: "radio",
                  name: "roster-service",
                  required: ""
                },
                domProps: {
                  value: _vm.ROSTER_SERVICE_CLEVER,
                  checked: _vm._q(
                    _vm.lambdaInput.roster_service,
                    _vm.ROSTER_SERVICE_CLEVER
                  )
                },
                on: {
                  change: function($event) {
                    return _vm.$set(
                      _vm.lambdaInput,
                      "roster_service",
                      _vm.ROSTER_SERVICE_CLEVER
                    )
                  }
                }
              }),
              _vm._v("\n          Clever\n        ")
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "radio-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.lambdaInput.roster_service,
                    expression: "lambdaInput.roster_service"
                  }
                ],
                attrs: { type: "radio", name: "roster-service" },
                domProps: {
                  value: _vm.ROSTER_SERVICE_ONEROSTER,
                  checked: _vm._q(
                    _vm.lambdaInput.roster_service,
                    _vm.ROSTER_SERVICE_ONEROSTER
                  )
                },
                on: {
                  change: function($event) {
                    return _vm.$set(
                      _vm.lambdaInput,
                      "roster_service",
                      _vm.ROSTER_SERVICE_ONEROSTER
                    )
                  }
                }
              }),
              _vm._v("\n          OneRoster\n        ")
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "radio-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.lambdaInput.roster_service,
                    expression: "lambdaInput.roster_service"
                  }
                ],
                attrs: { type: "radio", name: "roster-service" },
                domProps: {
                  value: _vm.ROSTER_SERVICE_S3CSV,
                  checked: _vm._q(
                    _vm.lambdaInput.roster_service,
                    _vm.ROSTER_SERVICE_S3CSV
                  )
                },
                on: {
                  change: function($event) {
                    return _vm.$set(
                      _vm.lambdaInput,
                      "roster_service",
                      _vm.ROSTER_SERVICE_S3CSV
                    )
                  }
                }
              }),
              _vm._v("\n          SFTP\n        ")
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.lambdaInput.roster_service === _vm.ROSTER_SERVICE_CLEVER
          ? _c("div", { staticClass: "panel panel-default" }, [
              _c("div", { staticClass: "panel-heading" }, [
                _vm._v("Clever Configuration")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "panel-body" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "clever-bearer-token" } }, [
                    _vm._v("Clever Bearer Token *")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.lambdaInput.clever_config.bearer_token,
                        expression: "lambdaInput.clever_config.bearer_token"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "clever-bearer-token",
                      type: "text",
                      required: "",
                      maxlength: "40",
                      minlength: "40"
                    },
                    domProps: {
                      value: _vm.lambdaInput.clever_config.bearer_token
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.lambdaInput.clever_config,
                          "bearer_token",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "help-block" }, [
                    _vm._v("The bearer token should be 40 characters long.")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v("District Admins")
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-info-circle",
                      attrs: { id: "district_admins_tooltip" }
                    }),
                    _vm._v(" "),
                    _c("tooltip", {
                      attrs: {
                        text:
                          "If the district is sharing admins via a sharing rule, select the default option.",
                        target: "#district_admins_tooltip"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "radio" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.districtAdminsInclusionType,
                              expression: "districtAdminsInclusionType"
                            }
                          ],
                          attrs: { type: "radio", value: "none" },
                          domProps: {
                            checked: _vm._q(
                              _vm.districtAdminsInclusionType,
                              "none"
                            )
                          },
                          on: {
                            change: function($event) {
                              _vm.districtAdminsInclusionType = "none"
                            }
                          }
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.DISTRICT_ADMINS_LABELS.none) +
                            "\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "radio" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.districtAdminsInclusionType,
                              expression: "districtAdminsInclusionType"
                            }
                          ],
                          attrs: { type: "radio", value: "all" },
                          domProps: {
                            checked: _vm._q(
                              _vm.districtAdminsInclusionType,
                              "all"
                            )
                          },
                          on: {
                            change: function($event) {
                              _vm.districtAdminsInclusionType = "all"
                            }
                          }
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.DISTRICT_ADMINS_LABELS.all) +
                            "\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "radio" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.districtAdminsInclusionType,
                              expression: "districtAdminsInclusionType"
                            }
                          ],
                          attrs: { type: "radio", value: "specific" },
                          domProps: {
                            checked: _vm._q(
                              _vm.districtAdminsInclusionType,
                              "specific"
                            )
                          },
                          on: {
                            change: function($event) {
                              _vm.districtAdminsInclusionType = "specific"
                            }
                          }
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.DISTRICT_ADMINS_LABELS.specific) +
                            "\n            "
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.districtAdminsInclusionType === "specific"
                  ? _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "district-admins" } }, [
                        _vm._v(
                          "District Admins to Include (one email per line)"
                        )
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.districtAdminsText,
                            expression: "districtAdminsText"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "district-admins",
                          rows: "5",
                          placeholder: "Enter one email address per line"
                        },
                        domProps: { value: _vm.districtAdminsText },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.districtAdminsText = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "help-block" }, [
                        _vm._v(
                          "\n            Specify district admin emails to include in the import. This would be admins not\n            configured in Clever sharing rules.\n          "
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.lambdaInput.roster_service === _vm.ROSTER_SERVICE_S3CSV
          ? _c("div", { staticClass: "panel panel-default" }, [
              _c("div", { staticClass: "panel-heading" }, [
                _vm._v("SFTP Autoprovisioning (CSV) Configuration")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "panel-body" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "s3-input-directory" } }, [
                      _vm._v("S3 CSV Input Directory *")
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-info-circle",
                      attrs: { id: "s3_input_directory_tooltip" }
                    }),
                    _vm._v(" "),
                    _c("tooltip", {
                      attrs: {
                        text:
                          "The district's S3 directory path where CSV files are uploaded via SFTP.",
                        target: "#s3_input_directory_tooltip"
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.lambdaInput.s3_csv_config.s3_prefix,
                          expression: "lambdaInput.s3_csv_config.s3_prefix"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "s3-input-directory",
                        type: "text",
                        required: "",
                        placeholder: "e.g., districtdirectory"
                      },
                      domProps: {
                        value: _vm.lambdaInput.s3_csv_config.s3_prefix
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.lambdaInput.s3_csv_config,
                            "s3_prefix",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "s3-filename-prefix" } }, [
                      _vm._v("File Name Prefix (optional)")
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-info-circle",
                      attrs: { id: "s3_filename_prefix_tooltip" }
                    }),
                    _vm._v(" "),
                    _c("tooltip", {
                      attrs: {
                        text:
                          "If your CSV files have a consistent prefix, enter it here. This helps the system filter the files to process. For example, if your files are named 'Full_users.csv', enter 'Full_'.",
                        target: "#s3_filename_prefix_tooltip"
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.lambdaInput.s3_csv_config.filename_prefix,
                          expression:
                            "lambdaInput.s3_csv_config.filename_prefix"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "s3-filename-prefix",
                        type: "text",
                        placeholder: "e.g., Full_"
                      },
                      domProps: {
                        value: _vm.lambdaInput.s3_csv_config.filename_prefix
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.lambdaInput.s3_csv_config,
                            "filename_prefix",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "checkbox" }, [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.customizeFieldMappings,
                            expression: "customizeFieldMappings"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.customizeFieldMappings)
                            ? _vm._i(_vm.customizeFieldMappings, null) > -1
                            : _vm.customizeFieldMappings
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.customizeFieldMappings,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.customizeFieldMappings = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.customizeFieldMappings = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.customizeFieldMappings = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("strong", [_vm._v("Customize CSV field mappings")])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(0)
                ]),
                _vm._v(" "),
                _vm.customizeFieldMappings
                  ? _c("div", [
                      _c("h5", [_vm._v("CSV Field Mappings")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "help-block" }, [
                        _vm._v(
                          "\n            Map the column names from the CSV file to the required fields. Column names are\n            case-sensitive.\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "csv-name-field" } }, [
                          _vm._v("Name Field *")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.lambdaInput.s3_csv_options.field_mappings
                                  .name_field,
                              expression:
                                "lambdaInput.s3_csv_options.field_mappings.name_field"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "csv-name-field",
                            type: "text",
                            required: _vm.customizeFieldMappings
                          },
                          domProps: {
                            value:
                              _vm.lambdaInput.s3_csv_options.field_mappings
                                .name_field
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.lambdaInput.s3_csv_options.field_mappings,
                                "name_field",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "csv-email-field" } }, [
                          _vm._v("Email Field *")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.lambdaInput.s3_csv_options.field_mappings
                                  .email_field,
                              expression:
                                "lambdaInput.s3_csv_options.field_mappings.email_field"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "csv-email-field",
                            type: "text",
                            required: _vm.customizeFieldMappings
                          },
                          domProps: {
                            value:
                              _vm.lambdaInput.s3_csv_options.field_mappings
                                .email_field
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.lambdaInput.s3_csv_options.field_mappings,
                                "email_field",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "csv-title-field" } }, [
                          _vm._v("Title Field *")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.lambdaInput.s3_csv_options.field_mappings
                                  .title_field,
                              expression:
                                "lambdaInput.s3_csv_options.field_mappings.title_field"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "csv-title-field",
                            type: "text",
                            required: _vm.customizeFieldMappings
                          },
                          domProps: {
                            value:
                              _vm.lambdaInput.s3_csv_options.field_mappings
                                .title_field
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.lambdaInput.s3_csv_options.field_mappings,
                                "title_field",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "csv-school-field" } }, [
                          _vm._v("School Field *")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.lambdaInput.s3_csv_options.field_mappings
                                  .school_field,
                              expression:
                                "lambdaInput.s3_csv_options.field_mappings.school_field"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "csv-school-field",
                            type: "text",
                            required: _vm.customizeFieldMappings
                          },
                          domProps: {
                            value:
                              _vm.lambdaInput.s3_csv_options.field_mappings
                                .school_field
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.lambdaInput.s3_csv_options.field_mappings,
                                "school_field",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          { attrs: { for: "csv-external-id-field" } },
                          [_vm._v("External ID Field (optional)")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.lambdaInput.s3_csv_options.field_mappings
                                  .external_id_field,
                              expression:
                                "lambdaInput.s3_csv_options.field_mappings.external_id_field"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { id: "csv-external-id-field", type: "text" },
                          domProps: {
                            value:
                              _vm.lambdaInput.s3_csv_options.field_mappings
                                .external_id_field
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.lambdaInput.s3_csv_options.field_mappings,
                                "external_id_field",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("p", { staticClass: "control-label" }, [
                    _vm._v("SFTP User Configuration (aka Transfer Family)")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "help-block" }, [
                    _vm._v(
                      "\n            This how the partner will have access to send us files via SFTP.\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default btn-sm",
                      attrs: { type: "button" },
                      on: { click: _vm.openTransferFamilyUserModal }
                    },
                    [_vm._v("\n            Manage SFTP User\n          ")]
                  ),
                  _vm._v(" "),
                  _vm.transferFamilyUser
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-danger btn-sm",
                          staticStyle: { "margin-left": "8px" },
                          attrs: { type: "button" },
                          on: { click: _vm.deleteTransferFamilyUser }
                        },
                        [_vm._v("\n            Delete SFTP User\n          ")]
                      )
                    : _vm._e()
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "modal",
          {
            attrs: {
              value: _vm.showTransferFamilyModal,
              title: "SFTP User Configuration"
            },
            on: {
              hide: function($event) {
                _vm.showTransferFamilyModal = false
              },
              input: function($event) {
                _vm.showTransferFamilyModal = $event
              }
            }
          },
          [
            _vm.transferFamilyUserFormModel
              ? _c("transfer-family-user-form", {
                  attrs: {
                    value: _vm.transferFamilyUserFormModel,
                    mode: _vm.transferFamilyUserMode
                  },
                  on: {
                    submit: _vm.handleTransferFamilyUserSubmit,
                    cancel: function($event) {
                      _vm.showTransferFamilyModal = false
                    }
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.lambdaInput.roster_service === _vm.ROSTER_SERVICE_ONEROSTER
          ? _c("div", { staticClass: "panel panel-default" }, [
              _c("div", { staticClass: "panel-heading" }, [
                _vm._v("OneRoster Configuration")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "panel-body" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "oneroster-client-id" } }, [
                    _vm._v("OneRoster Client ID *")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.lambdaInput.provider_config.client_id,
                        expression: "lambdaInput.provider_config.client_id"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "oneroster-client-id",
                      type: "text",
                      required: "",
                      "min-length": "10",
                      "max-length": "40"
                    },
                    domProps: {
                      value: _vm.lambdaInput.provider_config.client_id
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.lambdaInput.provider_config,
                          "client_id",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "oneroster-client-secret" } }, [
                    _vm._v("OneRoster Client Secret *")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.lambdaInput.provider_config.client_secret,
                        expression: "lambdaInput.provider_config.client_secret"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "oneroster-client-secret",
                      type: "text",
                      required: "",
                      "min-length": "10",
                      "max-length": "40"
                    },
                    domProps: {
                      value: _vm.lambdaInput.provider_config.client_secret
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.lambdaInput.provider_config,
                          "client_secret",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "oneroster-endpoint" } }, [
                    _vm._v("OneRoster Endpoint URL *")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.lambdaInput.provider_config.endpoint,
                        expression: "lambdaInput.provider_config.endpoint"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "oneroster-endpoint",
                      type: "text",
                      required: "",
                      placeholder: "https://demo-v2.rosterserver.com"
                    },
                    domProps: {
                      value: _vm.lambdaInput.provider_config.endpoint
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.lambdaInput.provider_config,
                          "endpoint",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "help-block" }, [
                    _vm._v("Enter the full URL including https://")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "oneroster-title-field" } }, [
                      _vm._v("OneRoster Title Field (optional)")
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-info-circle",
                      attrs: { id: "oneroster_title_tooltip" }
                    }),
                    _vm._v(" "),
                    _c("tooltip", {
                      attrs: {
                        text:
                          "If a domain has more specific job titles, they can share it as a metadata field. Insert the name of the metadata field here (with correct casing).",
                        target: "#oneroster_title_tooltip"
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.lambdaInput.oneroster_options
                              .metadata_title_field,
                          expression:
                            "lambdaInput.oneroster_options.metadata_title_field"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "oneroster-title-field", type: "text" },
                      domProps: {
                        value:
                          _vm.lambdaInput.oneroster_options.metadata_title_field
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.lambdaInput.oneroster_options,
                            "metadata_title_field",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "oneroster-unique-id" } }, [
                      _vm._v("OneRoster Unique ID")
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-info-circle",
                      attrs: { id: "oneroster_unique_id_tooltip" }
                    }),
                    _vm._v(" "),
                    _c("tooltip", {
                      attrs: {
                        text:
                          "Select the unique identifier for users. 'sourcedId' is the default and most commonly used.",
                        target: "#oneroster_unique_id_tooltip"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.lambdaInput.oneroster_options.unique_id_field,
                            expression:
                              "lambdaInput.oneroster_options.unique_id_field"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "oneroster-unique-id", required: "" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.lambdaInput.oneroster_options,
                              "unique_id_field",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "sourcedId" } }, [
                          _vm._v("sourcedId")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "email" } }, [
                          _vm._v("email")
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "oneroster-api-version" } }, [
                      _vm._v("OneRoster API Version")
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-info-circle",
                      attrs: { id: "oneroster_api_version_tooltip" }
                    }),
                    _vm._v(" "),
                    _c("tooltip", {
                      attrs: {
                        text:
                          "Select the OneRoster API version to use. 'v1.2' is the default and most commonly used.",
                        target: "#oneroster_api_version_tooltip"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.lambdaInput.provider_config.api_path_prefix,
                            expression:
                              "lambdaInput.provider_config.api_path_prefix"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "oneroster-api-version", required: "" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.lambdaInput.provider_config,
                              "api_path_prefix",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c(
                          "option",
                          { domProps: { value: _vm.oneRosterApiV2 } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getOneRosterApiVersionDisplay(
                                  _vm.oneRosterApiV2
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "option",
                          { domProps: { value: _vm.oneRosterApiV1 } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getOneRosterApiVersionDisplay(
                                  _vm.oneRosterApiV1
                                )
                              )
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("h4", [_vm._v("Import Options")]),
        _vm._v(" "),
        _c("div", { staticClass: "panel panel-default" }, [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.autocommit,
                        expression: "autocommit"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.autocommit)
                        ? _vm._i(_vm.autocommit, null) > -1
                        : _vm.autocommit
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.autocommit,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.autocommit = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.autocommit = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.autocommit = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Auto-commit Import")])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "help-block" }, [
                  _vm._v(
                    "\n              When enabled, imported user changes will automatically be saved. When disabled,\n              changes will need to be manually reviewed and committed.\n            "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.deactivateMissing,
                        expression: "deactivateMissing"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.deactivateMissing)
                        ? _vm._i(_vm.deactivateMissing, null) > -1
                        : _vm.deactivateMissing
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.deactivateMissing,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.deactivateMissing = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.deactivateMissing = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.deactivateMissing = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Auto-deactivate users")])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "help-block" }, [
                  _vm._v(
                    "\n              When enabled, this will automatically set the end date to the day of the import for\n              all missing users.\n            "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.autoupdateTitles,
                        expression: "autoupdateTitles"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.autoupdateTitles)
                        ? _vm._i(_vm.autoupdateTitles, null) > -1
                        : _vm.autoupdateTitles
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.autoupdateTitles,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.autoupdateTitles = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.autoupdateTitles = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.autoupdateTitles = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Auto-update titles")])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "help-block" }, [
                  _vm._v(
                    "\n              When enabled, imported users will receive titles from OneRoster/Clever. When\n              disabled, users will retain local titles.\n            "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.two_kit,
                        expression: "two_kit"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.two_kit)
                        ? _vm._i(_vm.two_kit, null) > -1
                        : _vm.two_kit
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.two_kit,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.two_kit = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.two_kit = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.two_kit = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Two Kit Import")])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "help-block" }, [
                  _vm._v(
                    "\n              When enabled, then all users in this import will receive Pathways licenses as well\n              as Toolkit\n            "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "csv-upload-prefix" } }, [
                _vm._v("S3 CSV Output Directory")
              ]),
              _vm._v(" "),
              _c("p", [
                _c("code", [
                  _vm._v(_vm._s(_vm.lambdaInput.csv_upload_s3_prefix))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "help-block" }, [
                _vm._v(
                  "\n            This prefix is automatically generated based on your domain information.\n          "
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.formValidationErrors.length > 0
          ? _c("div", { staticClass: "alert alert-warning" }, [
              _c("h5", [_vm._v("Please fix the following issues:")]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.formValidationErrors, function(error, index) {
                  return _c("li", { key: index }, [_vm._v(_vm._s(error))])
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: {
                type: "submit",
                disabled: _vm.loading || !_vm.isFormValid
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.isEdit ? "Update" : "Save") +
                  " Configuration\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-default",
              attrs: { type: "button" },
              on: { click: _vm.cancel }
            },
            [_vm._v("Cancel")]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "help-block" }, [
      _vm._v(
        "\n            If custom mappings aren't provided, the CSV must follow the\n            "
      ),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://docs.google.com/spreadsheets/d/1zdTr1k_WpdT_Jhk-a_XGkeLR2_rjcIEmbye5ouHr7aA/edit?gid=0#gid=0",
            rel: "noopener noreferrer",
            target: "_blank"
          }
        },
        [_vm._v("standard template format")]
      ),
      _vm._v(".\n          ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }